import React from 'react'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import BodyText from 'LuxKit/Typography/BodyText'
import { INCLUSIONS_TITLE_BONUS } from 'constants/inclusions'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

interface Props {
  inclusions: Array<App.PackageInclusion>;
}

export function HotelSummaryInclusions({ inclusions }: Props) {
  const bonusInclusions = inclusions.filter(inclusion => inclusion.isBonus)
  const regularInclusions = inclusions.filter(inclusion => !inclusion.isBonus)

  return (
    <VerticalSpacer gap={12}>
      {regularInclusions && regularInclusions.length > 0 && (
        <div>
          <BodyText variant="medium" weight="bold">Package inclusions:</BodyText>
          {regularInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} isHighlighted={inclusion.isHighlighted} />)}
        </div>
      )}
      {bonusInclusions && bonusInclusions.length > 0 && (
        <div>
          <BodyText variant="medium" weight="bold" format="propercase">{INCLUSIONS_TITLE_BONUS}:</BodyText>
          {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />)}
        </div>
      )}
    </VerticalSpacer>
  )
}
